// extracted by mini-css-extract-plugin
export default {"bulk-activation":"BulkEdit_bulk-activation__lAVaI","bulk-approval":"BulkEdit_bulk-approval__rDyfl","warning-modal":"BulkEdit_warning-modal__8tCoR"};